/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

const React = require("react")
const DefaultLayout = require("./src/layouts/Default").default

exports.wrapPageElement = ({ element, props }) => (
  <DefaultLayout {...props}>{element}</DefaultLayout>
)
